'use strict';

exports.__esModule = true;
exports['default'] = pureComponent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _validators = require('../../utils/validators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function pureComponent(target) {
  (0, _validators.validateClass)(target, 'pureComponent');

  Object.setPrototypeOf(target.prototype, _react2['default'].PureComponent.prototype);
  Object.setPrototypeOf(target, _react2['default'].PureComponent);
}


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/components/pureComponent.js
// module id = 554
// module chunks = 1